export default __webpack_public_path__ + "static/media/TransportationPlanes_08.fec4bf99.png";